import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Esto realmente me va a ayudar a organizar mi estudio contable?',
  answer: 'Sí. El sistema fue diseñado específicamente para contadores independientes que trabajan con múltiples clientes y necesitan un método claro para organizar tareas, vencimientos y documentación.'
}, {
  question: '¿Qué pasa si no soy muy organizado actualmente?',
  answer: 'Justamente este sistema está pensado para ayudarte a crear un método de trabajo más claro. No necesitas ser organizado previamente para empezar a aplicarlo.'
}, {
  question: '¿En cuánto tiempo puedo empezar a usar el sistema?',
  answer: 'La mayoría de los contadores pueden empezar a aplicarlo el mismo día que reciben el material, ya que el sistema está diseñado para ser simple y práctico.'
}, {
  question: '¿Este sistema sirve si tengo muchos clientes?',
  answer: 'Sí. De hecho, cuanto más clientes tengas, más útil se vuelve el sistema, porque te permite tener mayor control sobre vencimientos, documentos y tareas contables.'
}, {
  question: '¿El sistema reemplaza el software contable?',
  answer: 'No. El sistema no reemplaza el software contable, sino que te ayuda a organizar mejor tu trabajo y la gestión de tus clientes.'
}, {
  question: '¿Voy a recibir solo teoría o herramientas prácticas?',
  answer: 'El contenido está enfocado en herramientas prácticas y métodos aplicables para mejorar la organización de tu estudio contable.'
}, {
  question: '¿Este sistema sirve si recién estoy empezando como contador independiente?',
  answer: 'Sí. Puede ayudarte a comenzar con un sistema de trabajo más organizado desde el principio.'
}, {
  question: '¿Cómo recibo el material después de comprar?',
  answer: 'Una vez realizada la compra recibirás acceso inmediato al material digital para comenzar a utilizarlo.'
}, {
  question: '¿Qué pasa si el sistema no es lo que esperaba?',
  answer: 'Puedes probar el sistema con tranquilidad. Tienes una garantía de 7 días para solicitar la devolución si el contenido no cumple tus expectativas.'
}, {
  question: '¿Por qué este sistema puede marcar una diferencia en mi trabajo?',
  answer: 'Porque la mayoría de los contadores trabajan sin un sistema claro de organización. Tener un método estructurado para gestionar clientes, documentos y vencimientos puede mejorar mucho el control sobre tu trabajo diario.'
}];
export function FinalCTA() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-12 sm:py-20 px-4 bg-[#0B1A2E]" data-id="element-88">
      <div className="max-w-3xl mx-auto" data-id="element-89">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-90">
          <span className="inline-block text-blue-400 font-semibold tracking-wider text-xs sm:text-sm uppercase bg-blue-900/20 px-4 py-1.5 rounded-full border border-blue-800/40 mb-5" data-id="element-91">
            Resolvemos tus dudas
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-92">
            Preguntas frecuentes
          </h2>
        </motion.div>

        <div className="space-y-3" data-id="element-93">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.04
          }} className="bg-slate-800/40 border border-slate-700/50 rounded-xl overflow-hidden" data-id="element-94">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer" data-id="element-95">
                  <span className="text-base md:text-lg font-semibold text-white leading-snug" data-id="element-96">
                    {faq.question}
                  </span>
                  <motion.div animate={{
                rotate: isOpen ? 180 : 0
              }} transition={{
                duration: 0.2
              }} className="flex-shrink-0" data-id="element-97">
                    <ChevronDownIcon className="w-5 h-5 text-slate-400" data-id="element-98" />
                  </motion.div>
                </button>
                <AnimatePresence data-id="element-99">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25
              }} className="overflow-hidden" data-id="element-100">
                      <div className="px-5 pb-5 pt-0" data-id="element-101">
                        <p className="text-slate-300 text-sm md:text-base leading-relaxed" data-id="element-102">
                          {faq.answer}
                        </p>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>

        {/* Footer */}
        <div className="text-center mt-16 pt-6 border-t border-slate-800" data-id="element-103">
          <p className="text-xs text-slate-500 mb-2" data-id="element-104">
            Este producto es digital y se envía por correo electrónico
            inmediatamente después de la compra.
          </p>
          <p className="text-xs text-slate-600" data-id="element-105">
            © 2026 Sistema de Organización para Contadores. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </section>;
}